import { useState } from 'react';
import { FeedbackList } from '@/components/feedback/FeedbackList';
import { FeedbackSheet } from '@/components/feedback/FeedbackSheet';
import { trackFeedback } from '@/lib/rum';
import type { Feedback } from '@/types/feedback';

export function FeedbackPage() {
  const [selectedFeedback, setSelectedFeedback] = useState<Feedback | null>(null);
  const [isSheetOpen, setIsSheetOpen] = useState(false);

  const handleViewFeedbackDetails = (feedback: Feedback) => {
    setSelectedFeedback(feedback);
    setIsSheetOpen(true);
    trackFeedback.itemViewed(feedback.rowKey, feedback.vote);
  };

  const handleSheetOpenChange = (open: boolean) => {
    setIsSheetOpen(open);
    if (!open) {
      setSelectedFeedback(null);
    }
  };

  return (
    <>
      <div className="mb-6">
        <h1 className="text-3xl font-bold tracking-tight">Feedback</h1>
        <p className="mt-1 text-muted-foreground">
          Browse and analyse feedback collected across your accounts
        </p>
      </div>

      <FeedbackList onViewDetails={handleViewFeedbackDetails} />

      <FeedbackSheet
        open={isSheetOpen}
        feedback={selectedFeedback}
        onOpenChange={handleSheetOpenChange}
      />
    </>
  );
}
